import { useEffect } from 'react'
import { useRouteError } from 'react-router'
import { Button, EmptyRow } from '@/ui'
import { CenteredScreen } from '@/shell/CenteredScreen'
import { telemetry } from './telemetry'

/** Route-level error element: reports the error and offers a reload. */
export function RouteErrorBoundary() {
  const error = useRouteError()
  useEffect(() => {
    telemetry.captureError(error)
  }, [error])
  return (
    <CenteredScreen>
      <EmptyRow
        icon="error"
        title="Algo deu errado"
        description="Tivemos um problema inesperado. Recarregar a página costuma resolver."
      />
      <div style={{ display: 'flex', justifyContent: 'center', paddingBottom: 'var(--space-l)' }}>
        <Button icon="arrow_back" onClick={() => window.location.reload()}>
          Algo deu errado — recarregar
        </Button>
      </div>
    </CenteredScreen>
  )
}
